import { render, staticRenderFns } from "./applicationUsersSidebar.vue?vue&type=template&id=dbfabfe2&scoped=true"
import script from "./applicationUsersSidebar.vue?vue&type=script&lang=js"
export * from "./applicationUsersSidebar.vue?vue&type=script&lang=js"
import style0 from "./applicationUsersSidebar.vue?vue&type=style&index=0&id=dbfabfe2&prod&lang=scss&scoped=true"
import style1 from "./applicationUsersSidebar.vue?vue&type=style&index=1&id=dbfabfe2&prod&scoped=true&lang=css"
import style2 from "./applicationUsersSidebar.vue?vue&type=style&index=2&id=dbfabfe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfabfe2",
  null
  
)

export default component.exports